var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social_youtube_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.391 13.405c.368 1.304 1.492 1.542 1.567 1.588 1.85.504 12.221.506 14.1 0 1.286-.372 1.522-1.513 1.566-1.588.49-2.605.522-6.002-.022-8.958l.022.147c-.367-1.304-1.492-1.542-1.567-1.588-1.825-.496-12.223-.515-14.099 0C.672 3.379.436 4.519.391 4.594c-.524 2.738-.55 5.88 0 8.811zm6.815-1.667v-5.47l4.7 2.74-4.7 2.73z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social_youtube_svg__clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1em",
    height: "1em"
  })))));
}

export default SvgSocialYoutube;